export default __webpack_public_path__ + "static/media/familia-apache.9a1e814a.svg";